import { EventHelper } from "app/helpers/eventHelper";
import type { EventIncidentType, EventType } from "app/types/eventType";
import React from "react";

type Props = {
  event: EventType;
  period: string;
  eventIncidents: EventIncidentType[];
};

const AsianEventScoreExtraTime: React.FC<Props> = ({
  event,
  period,
  eventIncidents,
}) => {
  const periodType =
    period === "fullTime" ? "scoreDetails" : "currentPeriodScoreDetails";
  const homeScoreFullTime = EventHelper.getHomeScore(
    eventIncidents[0][`${periodType}`]
  );
  const awayScoreFullTime = EventHelper.getAwayScore(
    eventIncidents[0][`${periodType}`]
  );
  const homeScoreExtraTimeFT = EventHelper.getHomeScore(
    eventIncidents[0][`scoreDetails`]
  );
  const awayScoreExtraTimeFT = EventHelper.getAwayScore(
    eventIncidents[0][`scoreDetails`]
  );

  return (
    <div className="asian-event__score">
      {event.showHomePlayerAsFirst ? (
        <>
          <div>
            {homeScoreFullTime} - {awayScoreFullTime} ET
          </div>
          <div>
            {homeScoreExtraTimeFT} - {awayScoreExtraTimeFT} FT
          </div>
        </>
      ) : (
        <>
          <div>
            {awayScoreFullTime} - {homeScoreFullTime} ET
          </div>
          <div>
            {awayScoreExtraTimeFT} - {homeScoreExtraTimeFT} FT
          </div>
        </>
      )}
    </div>
  );
};

export default AsianEventScoreExtraTime;
